module.exports = __webpack_public_path__ + "static/icon-2-yellow-e6b4d8501d2424bc2ea59b12f15eaed4.png";